import type { WithGridElementAttentionStatus } from '../../evaluation/AttentionStatus';
import type { GridElementLoadFlowDetails } from '../gridElementsDetailsByCalculationType/loadFlow/gridElementLoadFlowDetails.types';
import type { GridElementShortCircuitDetails } from '../gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitDetails';
import { GridElementDictionary } from './GridElementDictionary';

export class GridElements {
  constructor(private readonly mapElementsDictionary: GridElementDictionary) {}

  static fromAllCalculationTypes(
    shortCircuitDetailsWithStatus: WithGridElementAttentionStatus<GridElementShortCircuitDetails>[],
    loadFlowDetailsWithStatus: WithGridElementAttentionStatus<GridElementLoadFlowDetails>[]
  ) {
    const dictionary = [
      ...loadFlowDetailsWithStatus,
      ...shortCircuitDetailsWithStatus
    ].reduce<GridElementDictionary>((mapElements, details) => {
      mapElements.forElement(details.id, {
        exists: mapElement => {
          mapElements.replace(
            mapElement.copyWithHigherAttentionStatus(details.status)
          );
        },
        missing: () => {
          mapElements.add(details);
        }
      });

      return mapElements;
    }, new GridElementDictionary());

    return new GridElements(dictionary);
  }

  /*
  static fromGridElementsDetailsByCalculationType(
      gridElementsDetails: GridElementsDetailsByCalculationType,
      statusProvider: ForProvidingAttentionStatus
  ) {
    const dictionary = [
      ...gridElementsDetails.loadFlow,
      ...gridElementsDetails.shortCircuit
    ].reduce<GridElementDictionary>((gridElements, details) => {
      gridElements.forElement(details.id, {
        exists: doNothing,
        missing: () => {
          gridElements.add(GridElement.FromDetails(details, statusProvider.getByElementId(details.id)));
        }
      });

      return gridElements;
    }, new GridElementDictionary());

    return new GridElements(dictionary);
  }
*/
  toArray() {
    return this.mapElementsDictionary.toArray();
  }

  toRecord() {
    return this.mapElementsDictionary.toRecord();
  }
}

// const doNothing = () => { };
